import {DateTime} from 'luxon';
import {CLStore} from 'common/src/redux/store';
import {ToolExecuteParams} from 'common/src/modules/shared/copilot/copilot.types';
import {addOrUpdateCardInputSchema} from '../../../../schemas/baseSchemas';
import getAddOrUpdateCardPrompt from '../../../../tools/general/addOrUpdateCardTool/utils/getAddOrUpdateCardPrompt';

export default function preProcessStandaloneAgent<TScratchpad>(
  params: ToolExecuteParams<typeof addOrUpdateCardInputSchema, TScratchpad>,
  store: CLStore,
) {
  const {prompt, cardId: cardIdInput = 0} = params.input;

  const normalizedCardId = cardIdInput ?? 0;

  const promptWithDateInstructions = prompt.concat(
    `\n When using dates, use the ISO format for the dates. 
      Today's date is ${DateTime.now().toISO()}.`,
  );

  const promptToUse = getAddOrUpdateCardPrompt({
    prompt: promptWithDateInstructions,
    cardId: normalizedCardId,
    store,
  });

  return {
    promptToUse,
    normalizedCardId,
  };
}
